import { AT } from '../../../actions/actionTypes';
import { useState } from 'react';
import { Activity } from './model';
import { CallStatusDefault, FeedbackAddPL } from '../../../models';
import Logger from '../../../libs/logger';  import { LogArea } from '../../../libs/logger/const';
import * as MyKeysApiTransfer from '../../../core/apis/mykeys/transfer';
import { MyKeysPromiseMap } from '../../../core/apis/mykeys/mappings';
import { fetch, success, error } from '../../../utils/callStatus';
import { ErrorDataResponse } from '../../../interfaces';
import useDispatcher from '../../../hooks/useDispatcher';
import useUserEKS from '../../../hooks/useUserEKS';
import { isSender } from './utils';
import useHistorical from '../../historical/useHistorical';
import useTx from './useTx';
import * as m from './messages';

export const useTxActivityLog = (a: Activity) => {
  const { showTxDevices, refreshData } = useTx();
  const { doAction } = useDispatcher();
  const { onRemoveLog } = useHistorical<Activity>();
  const { customer } = useUserEKS();
  const isViewedBySender = isSender(a, customer?.customerName);
  const [responseStatus, setResponseStatus] = useState(CallStatusDefault);

  const onAccept = () => {
    Logger.info(['acceptRequest', a.id], LogArea.Redux);
    MyKeysApiTransfer.acceptTransferRequest(a)
      .then(MyKeysPromiseMap)
      .then((data: boolean) => {
        if (!data) throw new Error('unexpected flow');
        setResponseStatus((s) => success(s));
        refreshData();
        doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_SUCCESS, {
          content: [m.msgReqAcceptedSucceed],
        });
        onRemoveLog && onRemoveLog(a);
      })
      .catch((err: ErrorDataResponse) => {
        const errMsg = m.msgReqAcceptedError;
        setResponseStatus((s) => error(s, errMsg));
        doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, {
          content: [errMsg],
        });
      });
    setResponseStatus((s) => fetch(s));
  };

  const onReject = () => {
    Logger.info(['onReject', a.id], LogArea.Redux);
    MyKeysApiTransfer.rejectTransferRequest(a)
      .then(MyKeysPromiseMap)
      .then((data: boolean) => {
        if (!data) throw new Error('unexpected flow');
        setResponseStatus((s) => success(s));
        doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, {
          content: [m.msgReqDenySucceed],
        });
        onRemoveLog && onRemoveLog(a);
      })
      .catch((err: ErrorDataResponse) => {
        const errMsg = m.msgReqDenyError;
        setResponseStatus((s) => error(s, errMsg));
        doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, {
          content: [errMsg],
        });
      });
    setResponseStatus((s) => fetch(s));
  };

  const onCancel = () => {
    Logger.info(['onCancel', a.id], LogArea.Redux);
    MyKeysApiTransfer.cancelTransferRequest(a)
      .then(MyKeysPromiseMap)
      .then((data: boolean) => {
        if (!data) throw new Error('unexpected flow');
        setResponseStatus((s) => success(s));
        doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, {
          content: [m.msgReqCancelSucceed],
        });
        onRemoveLog && onRemoveLog(a);
      })
      .catch((err: ErrorDataResponse) => {
        const errMsg = m.msgReqCancelError;
        setResponseStatus((s) => error(s, errMsg));
        doAction<FeedbackAddPL>(AT.FEEDBACK_ADD_ERROR, {
          content: [errMsg],
        });
      });
    setResponseStatus((s) => fetch(s));
  };

  const onDetails = () => showTxDevices(a.id, a.devices);

  return {
    onAccept,
    onReject,
    onCancel,
    onDetails,
    responseStatus,
    isViewedBySender,
  };
};

export default useTxActivityLog;
